import * as _ from 'lodash';
import { useEffect, useState, type VoidFunctionComponent } from 'react';

import Locator from '../../../../../../shared/Locator';
import { Action } from '../../../../../../typings/permissions';
import useCorrectDependencyMetadata from '../../../../../hooks/api/correctionsV2/useCorrectDependencyMetadata';
import useHasProjectPermission from '../../../../../shared/permissions/useHasProjectPermission';
import Button from '../../../../generic/Button/Button';
import { BUTTON_SIZE, BUTTON_TYPE } from '../../../../generic/Button/button-constants';
import MultiTextInput from '../../../../generic/Forms/MultiTextInput';
import type { Dependency } from '../../../../../../shared/dependenciesV2';

import styles from '../DependencyDrawer.module.less';

type Props = {
  dependency: Dependency;
};

export const DependencyAuthors: VoidFunctionComponent<Props> = ({ dependency }) => {
  const [values, setValues] = useState<{ authors: string[] }>({ authors: dependency.authors });
  const [isDirty, setIsDirty] = useState(false);
  const { mutate: upsertCorrection } = useCorrectDependencyMetadata(dependency.locator);

  const canEditAuthors = useHasProjectPermission(Locator.parsePackageString(dependency.locator), Action.Edit);

  const onSave = () => {
    upsertCorrection({ correctionData: { authors: values.authors }, revisionLocator: dependency.locator });
    setIsDirty(false);
  };

  useEffect(() => {
    setIsDirty(!_.isEqual(dependency.authors, values.authors));
  }, [dependency.authors, values.authors]);

  return (
    <div>
      <div className={styles.header}>Authors</div>
      <div className={styles.authors}>
        <MultiTextInput
          id="authors"
          name="authors"
          label="Authors"
          size="medium"
          values={dependency.authors}
          onChange={(authors) => setValues({ ...values, authors })}
          isDisabled={!canEditAuthors}
        />
        {canEditAuthors && <div className={styles.authorsHint}>Press enter after entering each author.</div>}
      </div>
      <hr />
      <div className={styles.footer}>
        <Button
          type={BUTTON_TYPE.PRIMARY}
          size={BUTTON_SIZE.MEDIUM}
          onClick={onSave}
          isDisabled={!isDirty || !canEditAuthors}
        >
          Save
        </Button>
      </div>
    </div>
  );
};
